import { render, staticRenderFns } from "./newRegionPkg.vue?vue&type=template&id=0ef936dd&scoped=true&"
import script from "./newRegionPkg.vue?vue&type=script&lang=js&"
export * from "./newRegionPkg.vue?vue&type=script&lang=js&"
import style0 from "./newRegionPkg.vue?vue&type=style&index=0&id=0ef936dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef936dd",
  null
  
)

export default component.exports